// extracted by mini-css-extract-plugin
module.exports = {"root":"Benefits_root__8qe2D"};